import { IconProps } from "src/shared/icons/interfaces/IconProps.interface"

function Clean(props: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
            <circle cx={7} cy={7} r={7} fill="#5374AE" />
            <path
                fill="#fff"
                d="m5.93 4.61-.432-.713c-.161-.263-.48-.41-.78-.323a.69.69 0 0 0-.4 1.016l.443.73c.05.078.155.105.233.058l.878-.535a.167.167 0 0 0 .057-.233ZM9.604 7.744l-.945-1.28a1.362 1.362 0 0 0-1.44-.508c0-.003-.004-.003-.004-.006l-.559-.919a.343.343 0 0 0-.468-.111l-1.167.71a.339.339 0 0 0-.115.468l.555.919s0 .003.004.003a1.362 1.362 0 0 0-.206 1.518l.7 1.427a.84.84 0 0 0 1.155.387c.033-.017.044-.058.023-.091l-.525-.868a.257.257 0 0 1 .084-.354.264.264 0 0 1 .354.084l.528.869c.02.03.06.04.091.023l.323-.195a.07.07 0 0 0 .024-.09l-.529-.87a.264.264 0 0 1 .084-.353.262.262 0 0 1 .354.085l.528.868c.02.03.06.04.091.023l.323-.195a.07.07 0 0 0 .024-.09l-.529-.869a.264.264 0 0 1 .084-.353.262.262 0 0 1 .354.084l.532.865c.02.03.06.04.09.02a.837.837 0 0 0 .182-1.202Z"
            />
        </svg>
    )
}

export default Clean
